import * as React from 'react';
import { ActionParams } from '../types';
import { Actions } from '../stores/ActionStore';

export type ActionId = keyof typeof Actions;

export interface ContractActionHandler {
    dispatch(actionId: ActionId, params?: ActionParams): Promise<void>;
}

export const ContractActionContext = React.createContext<ContractActionHandler | null>(null);

export const useContractActions = () => {
    const context = React.useContext(ContractActionContext);

    if (!context) {
        throw new Error('ContractActionContext.Provider is missing in component tree.');
    }

    return context;
};
